import React, { memo } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { listingTypes } from "../data";
import { MdQuestionMark } from "react-icons/md";
import Swal from "sweetalert2";

/**
 * A form field component for selecting the listing type using react-hook-form
 * and styled with Tailwind CSS.
 * This component is memoized for performance.
 */
const ListingFormFields = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext(); // Access form context for form state

  return (
    <div className="flex flex-col gap-4">
      {/* Listing Type Field */}
      <Controller
        name="listing_type"
        control={control}
        render={({ field: { onChange, value } }) => (
          <div className="relative">
            <label
              htmlFor="listing_type"
              className="mb-1 flex items-center text-sm font-medium text-gray-700"
            >
              Listing Type
              <MdQuestionMark
                onClick={() =>
                  Swal.fire({
                    text: "Listing type",
                    icon: "question",
                  })
                }
                style={{
                  color: "#fff",
                  background: "#8ec639",
                  borderRadius: "50%",
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                  marginLeft: "8px",
                  boxShadow: "0 0 8px 2px #8ec639, 0 0 0 3px #c6f6d5",
                  border: "2px solid #8ec639",
                  cursor: "pointer",
                  padding: "2px",
                  animation: "pulse-glow 1.2s infinite alternate",
                }}
                className="focus:outline-none focus:ring-2 focus:ring-[#8ec639]"
                title="What does this mean? Click for info."
              />
            </label>
            <select
              id="listing_type"
              className={`w-full rounded-md border px-4 py-3  ${
                errors?.listing_type?.message
                  ? "border-red-500"
                  : "border-gray-300"
              }`}
              value={value || ""}
              onChange={onChange}
            >
              <option value="" disabled>
                Select a listing type
              </option>
              {listingTypes.map((option) => (
                <option
                  key={option.key}
                  value={option.value}
                  disabled={option.disabled}
                >
                  {option.label}
                </option>
              ))}
            </select>
            {errors?.listing_type?.message && (
              <p className="mt-1 text-sm text-red-500">
                {errors.listing_type.message}
              </p>
            )}
          </div>
        )}
      />
    </div>
  );
};

export default memo(ListingFormFields);
